import { ChangeEvent, FC, useCallback, useEffect, useState } from "react";
import { TextareaAutosize, TextareaAutosizeProps } from "@mui/material";
import useDebounce from "helpers/useDebounce";
import { DebouncedTextProps } from "./DebouncedText";
import { TextareaStyle } from "theme";

const DebouncedTextarea: FC<
  DebouncedTextProps & {
    minRows?: number;
    maxRows?: number;
    textareaProps?: TextareaAutosizeProps;
  }
> = (props) => {
  const { value, onChange, formatter } = props;
  const delay = props.delayMs || 500;

  const [internalValue, setInternalValue] = useState(value);

  const debouncedValue = useDebounce(internalValue, delay);

  const handleInputChange = useCallback(
    (evt: ChangeEvent<HTMLTextAreaElement>) => {
      // Apply formatter if provided
      setInternalValue(formatter ? formatter(evt.target.value) : evt.target.value);
    },
    [setInternalValue]
  );

  useEffect(() => {
    if (value !== internalValue) {
      setInternalValue(value);
    }
  }, [value]);

  useEffect(() => {
    if (debouncedValue !== value) {
      onChange(debouncedValue);
    }
  }, [debouncedValue]);

  return (
    <TextareaAutosize
      minRows={props.minRows ?? 12}
      maxRows={props.maxRows ?? 12}
      style={TextareaStyle}
      value={internalValue}
      onChange={handleInputChange}
      {...props.textareaProps}
    />
  );
};

export default DebouncedTextarea;
